export function isTimedItem(item) {
    return Boolean(item.sessionId);
}
